
import React from 'react';
import Layout from '@/components/layout/Layout';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import FinanceConfirmedPaymentsList from '@/components/finance/FinanceConfirmedPaymentsList';

const FinancePaymentsConfirmed = () => {
  return (
    <Layout>
      <div className="w-full max-w-full py-8">
        <h1 className="text-3xl font-bold mb-8">Confirmed Payments</h1>
        
        <Card className="w-full">
          <CardHeader>
            <CardTitle>Confirmed Payments</CardTitle>
            <CardDescription>
              Procurements with confirmed payments
            </CardDescription>
          </CardHeader>
          <CardContent>
            <FinanceConfirmedPaymentsList />
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default FinancePaymentsConfirmed;
